function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6666 12H0.333252V10.6667H0.999919V0.666667C0.999919 0.489856 1.07016 0.320286 1.19518 0.195262C1.32021 0.0702379 1.48977 0 1.66659 0H10.9999C11.1767 0 11.3463 0.0702379 11.4713 0.195262C11.5963 0.320286 11.6666 0.489856 11.6666 0.666667V4H12.9999V10.6667H13.6666V12ZM10.3333 10.6667H11.6666V5.33333H7.66659V10.6667H8.99992V6.66667H10.3333V10.6667ZM10.3333 4V1.33333H2.33325V10.6667H6.33325V4H10.3333ZM3.66659 5.33333H4.99992V6.66667H3.66659V5.33333ZM3.66659 8H4.99992V9.33333H3.66659V8ZM3.66659 2.66667H4.99992V4H3.66659V2.66667Z",
  fill: "#C2BFC6"
});

var SvgCompanyIcon = function SvgCompanyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompanyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CompanyIcon.b88af11a.svg";
export { ForwardRef as ReactComponent };